import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-810b2460"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  style: {"width":"3rem","height":"3rem"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_5 = {
  key: 2,
  class: "text-center",
  style: {"color":"#072878"}
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  "aria-label": "",
  style: {"color":"#072878"}
}
const _hoisted_8 = { class: "pagination justify-content-center" }
const _hoisted_9 = ["onClick"]

import { ref, onMounted, Ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Chapter, Page } from '@/data/models/Story'
import ChapterDao from '@/data/dao/ChapterDao'
import PageDao from '@/data/dao/PageDao'
import Resource from '@/data/tools/Resource'


export default /*#__PURE__*/_defineComponent({
  __name: 'PagesPage',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const c = new ChapterDao()
const p = new PageDao()

const chapter: Ref<Chapter | null> = ref(null)
const page: Ref<Page | null> = ref(null)

const loading = ref(false)
const error = ref(false)

async function getChapter() {
  await c.getChapter(
    route.params.id_story.toString(),
    route.params.id_chapter.toString(),
    (resource: Resource) => {
      switch (resource.status) {
        case Resource.LOADING:
          loading.value = true
          break
        case Resource.ERROR:
          error.value = true
          loading.value = false
          break
        case Resource.SUCCESS:
          chapter.value = resource.data
          loading.value = false
          break
        default:
          break
      }
    }
  )
}

async function getPage(numberPage: number) {
  await p.getPage(
    route.params.id_story.toString(),
    chapter.value!.id,
    numberPage,
    (resource: Resource) => {
      switch (resource.status) {
        case Resource.LOADING:
          loading.value = true
          break
        case Resource.ERROR:
          error.value = true
          loading.value = false
          break
        case Resource.SUCCESS:
          page.value = resource.data[0]
          router.push(
            `/storie/${route.params.id_story.toString()}/chapter/${
              route.params.id_chapter
            }/page/${numberPage}`
          )
          loading.value = false
          break
        default:
          break
      }
    }
  )
}

onMounted(async () => {
  if (route.params.id_story && route.params.id_chapter) {
    await getChapter()
    if (chapter) {
      await getPage(1)
    } else {
      router.replace('/stories')
    }
  } else {
    router.replace('/stories')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Error obteniendo la página! "))
      : _createCommentVNode("", true),
    (chapter.value)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(chapter.value.title), 1))
      : _createCommentVNode("", true),
    (page.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "container",
          innerHTML: page.value.content
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapter.value?.numberPages, (c, i) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(
          i + 1 === Number(_unref(route).params.numero_pagina)
            ? 'page-item active'
            : 'page-item'
        ),
            key: i
          }, [
            _createElementVNode("a", {
              class: "page-link cursor",
              onClick: ($event: any) => (getPage(i + 1))
            }, _toDisplayString(i + 1), 9, _hoisted_9)
          ], 2))
        }), 128))
      ])
    ])
  ], 64))
}
}

})